import styled, { useTheme } from 'styled-components';
import { PSmall } from './Text';

const BadgeWrapper = styled.div<{ backgroundColor: string; color: string }>`
  flex-direction: row;
  display: flex;
  margin-top: 16px;
  border-radius: 200px;
  gap: 7px;
  align-items: center;

  padding: 8px 16px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  p {
    color: ${({ color }) => color};
  }
`;

const BadgeText = styled(PSmall)`
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  padding-bottom: 0;
`;

const FontAwesomeIcon = styled.i`
  color: ${({ color }) => color};
  font-size: 12px;
`;

export default function Badge({
  isPrimary,
  colors = null,
  label,
  faIcon = null,
  className = '',
  style,
  children,
}: {
  isPrimary?: boolean;
  colors?: {
    textColor: string;
    backgroundColor: string;
  } | null;
  label?: string;
  faIcon?: string | null;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  const theme = useTheme();

  const badgeColors =
    colors ||
    (isPrimary
      ? {
          textColor: theme.colors.bgPage,
          backgroundColor: theme.colors.primary,
        }
      : {
          textColor: theme.colors.textSecondary,
          backgroundColor: theme.colors.transparentBg,
        });
  return (
    <BadgeWrapper
      style={style}
      className={className}
      color={badgeColors.textColor}
      backgroundColor={badgeColors.backgroundColor}
    >
      {label && <BadgeText>{label}</BadgeText>}
      {faIcon && (
        <FontAwesomeIcon className={faIcon} color={badgeColors.textColor} />
      )}
      {children}
    </BadgeWrapper>
  );
}

export const SmallBadge = styled(Badge)`
  width: fit-content;
  margin-top: 0;
  /* justify-self: center; */
  padding: 4px 8px;
  p {
    font-size: 13px;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
  }
`;
